import { useCallback, useState } from 'react';

import { useUserContext } from '@/features/common/contexts/user.context';
import { beContacted } from '@/services/job';

export type UseBeContactedReturn = {
  loading: boolean;
  error: string | null;
  request: () => Promise<boolean>;
};

export function useBeContacted(): UseBeContactedReturn {
  const { user } = useUserContext();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const request = useCallback(async () => {
    if (!user?.id) {
      setError('User not found');
      return false;
    }

    setLoading(true);
    setError(null);
    try {
      await beContacted();
      return true;
    } catch {
      setError('Failed to submit request');
      return false;
    } finally {
      setLoading(false);
    }
  }, [user?.id]);

  return { loading, error, request };
}
